import { render, staticRenderFns } from "./PostUserInfo.vue?vue&type=template&id=3a744552&scoped=true&"
import script from "./PostUserInfo.vue?vue&type=script&lang=js&"
export * from "./PostUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a744552",
  null
  
)

export default component.exports